import { render, staticRenderFns } from "./chainCreationModal.vue?vue&type=template&id=45e6ed6e&"
import script from "./chainCreationModal.vue?vue&type=script&lang=js&"
export * from "./chainCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports